import type { ReactNode } from "react";
import type { StatusTone } from "@/lib/status";
import "./StatusPill.css";

/** Generic status pill — same chrome as the quote {@link StatusPill}, but the
 *  caller supplies the tone + label so it works for any domain (job status,
 *  application status/decision, task status/priority). */
export function Pill({
  tone = "neutral",
  title,
  children,
}: {
  tone?: StatusTone;
  title?: string;
  children: ReactNode;
}) {
  return (
    <span className={`pill pill--${tone}`} title={title}>
      <span className="pill__dot" aria-hidden="true" />
      {children}
    </span>
  );
}
